import { useState } from "react";
import Image1 from "../Assests/ProgramImages/20251114_105650 (1).jpg"
import Image2 from "../Assests/About/eps.jpg"



const stats = [
  { value: "2018", label: "Founded" },
  { value: "2+", label: "Branches" },
  { value: "6+", label: "Programs" },
  { value: "27yrs", label: "Leadership Experience" },
];

const team = [
  {
    name: "Preethi Ananth",
    role: "Director & Founder",
    bio: "Meet our founder — an MBA graduate with a deep passion for early childhood education and over 20 years of experience in academics and child development. Known for her patience, warmth, and nurturing approach, she has created a learning environment where every child feels safe, valued, and encouraged to grow with confidence. Her gentle leadership, kindness, and genuine care for children have earned the trust and admiration of parents, teachers, and staff alike. She believes that the early years shape a child’s future, and her vision is to build a preschool experience that blends love, learning, creativity, and strong values in every child’s journey.",
    emoji: "👩‍🏫",
    color: "from-teal-400 to-cyan-500",
  },
];

const values = [
  {
    icon: "🌱",
    title: "Holistic Development",
    desc: "We empower children to grow physically, socially, and emotionally through exploration and caring guidance.",
    color: "bg-teal-50 border-teal-200",
    iconBg: "bg-teal-600",
  },
  {
    icon: "🎨",
    title: "Multiple Intelligence",
    desc: "Based on Howard Gardner's MI theory — we nurture all 8 intelligences in every child, celebrating unique strengths.",
    color: "bg-orange-50 border-orange-200",
    iconBg: "bg-orange-500",
  },
  {
    icon: "🧩",
    title: "Montessori Pedagogy",
    desc: "Hands-on learning that fosters independence and self-directed exploration in a nurturing environment.",
    color: "bg-violet-50 border-violet-200",
    iconBg: "bg-violet-600",
  },
  {
    icon: "💡",
    title: "Curiosity First",
    desc: "We create a safe, inclusive, vibrant space where curiosity is sparked and creativity is nurtured every day.",
    color: "bg-yellow-50 border-yellow-200",
    iconBg: "bg-yellow-500",
  },
];

const programs = [
  { label: "Toddler Program", age: "1.5+", desc: "Fine motor skills, social interaction & musical concepts through guided play.", emoji: "🍼", color: "bg-teal-100 text-teal-800" },
  { label: "Play Group", age: "2+", desc: "Self-directed exploration, social communication & musical intelligence.", emoji: "🧸", color: "bg-orange-100 text-orange-800" },
  { label: "Nursery", age: "3+", desc: "Creative expression, basic shapes/colors & bodily-kinesthetic intelligence.", emoji: "🎨", color: "bg-pink-100 text-pink-800" },
  { label: "Jr KG", age: "4+", desc: "Phonics, letter recognition, critical thinking & spatial intelligence.", emoji: "📚", color: "bg-indigo-100 text-indigo-800" },
  { label: "Sr KG", age: "5+", desc: "Research skills, group discussions & creative presentations.", emoji: "🔬", color: "bg-violet-100 text-violet-800" },
  { label: "Day Care", age: "1+", desc: "Gadget-free, fun indoor/outdoor play in a social & engaging atmosphere.", emoji: "☀️", color: "bg-yellow-100 text-yellow-800" },
];

const milestones = [
  { year: "2018", text: "Seekers Bay Preschool founded with a mission for quality early childhood education." },
  { year: "2020", text: "Grew and innovated even through the pandemic with new learning materials." },
  { year: "2023", text: "Second branch opened at Naganathapura, expanding access in Bangalore." },
  { year: "Now", text: "Trusted by hundreds of families, backed by leaders running 2000+ preschools across India." },
];

const faqs = [
  { q: "What are your hours of operation?", a: "Open today: 08:30 am – 05:00 pm | School time: Monday to Saturday, 08:30 am – 05:00 pm | Sunday Closed" },
  { q: "What age range do you accept?", a: "We accept children from 12 months to 6+ years old across our various programs." },
  { q: "What curriculum do you follow?", a: "We combine Montessori pedagogy with Howard Gardner's Multiple Intelligence (MI) theory — a personalized, holistic approach that nurtures each child's unique strengths." },
  { q: "What makes Seekers Bay unique?", a: "We go the extra mile to ensure your child is valued. We integrate Montessori & MI philosophy into a unique curriculum, continuously innovating to create a happy, stimulating atmosphere." },
  { q: "Will my child be labeled by a specific intelligence?", a: "No — MI is not meant to categorize children. It's a framework for educators to understand how each child learns best. We encourage exploration across all intelligences." },
];

function FAQ() {
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-3">
      {faqs.map((f, i) => (
        <div key={i} className="border border-gray-200 rounded-xl overflow-hidden">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-left font-semibold text-gray-800 hover:bg-gray-50 transition-colors text-sm md:text-base"
            onClick={() => setOpen(open === i ? null : i)}
          >
            <span className="pr-4">{f.q}</span>
            <span className="flex-shrink-0 text-teal-600 text-xl font-bold">{open === i ? "−" : "+"}</span>
          </button>
          {open === i && (
            <div className="px-5 pb-5 text-gray-600 text-sm leading-relaxed border-t border-gray-100 pt-3">
              {f.a}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-800">

      {/* ── HERO ── */}
     <div className="bg-[rgb(122,49,125)] text-white py-14 px-6 text-center">
        <p className="text-sm uppercase tracking-widest text-teal-300 mb-2">Our Programs</p>
        <h1 className="text-3xl md:text-5xl font-extrabold">
          About Seekers Bay Preschool
        </h1>
        <p className="mt-3 text-teal-200 max-w-xl mx-auto text-sm md:text-base">
          Nurturing every child's unique potential through play, creativity, and guided learning.
        </p>
      </div>
      {/* ── OUR VISION ── */}
      <section className="max-w-6xl mx-auto px-5 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Illustration */}
         <div className="flex-shrink-0 w-full lg:w-96">
  <div className="rounded-3xl bg-gradient-to-br from-teal-100 to-cyan-100 h-72 md:h-80 flex items-center justify-center relative overflow-hidden border border-teal-200">
    <img 
      src={Image1}
      alt="Our Vision"
      className="w-full h-full object-cover"
    />
  </div>
</div>
          <div className="flex-1">
            <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Who We Are</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-5 leading-snug">
              We Celebrate Every Child's <span className="text-teal-700">Unique Journey</span>
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              We create a safe, inclusive, vibrant space where <strong>curiosity is sparked</strong>, creativity is nurtured, and each child's individuality shines.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Through exploration and caring guidance, we empower children to grow <strong>physically, socially, and emotionally</strong> — ensuring holistic development at every stage.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center gap-3 bg-teal-50 border border-teal-200 rounded-xl px-5 py-3">
                <span className="text-2xl">🏫</span>
                <div>
                  <p className="font-bold text-teal-800 text-sm">2 Branches</p>
                  <p className="text-xs text-gray-500">Bangalore, Karnataka</p>
                </div>
              </div>
              <div className="flex items-center gap-3 bg-orange-50 border border-orange-200 rounded-xl px-5 py-3">
                <span className="text-2xl">🎓</span>
                <div>
                  <p className="font-bold text-orange-700 text-sm">Est. 2018</p>
                  <p className="text-xs text-gray-500">Trusted since day one</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── OUR VALUES ── */}
      <section className="bg-gray-50 py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center mb-10">
            <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Our Approach</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">What Drives Us</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v, i) => (
              <div key={i} className={`rounded-2xl border p-6 ${v.color} hover:shadow-md transition-shadow`}>
                <div className={`w-12 h-12 ${v.iconBg} rounded-xl flex items-center justify-center text-white text-2xl mb-4`}>
                  {v.icon}
                </div>
                <h3 className="font-bold text-gray-900 mb-2 text-base">{v.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROGRAMS / LEARNING HUBS ── */}
      <section id="programs" className="max-w-6xl mx-auto px-5 py-16 md:py-20">
        <div className="text-center mb-10">
          <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Learning Hubs</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">Our Programs</h2>
          <p className="text-gray-500 mt-2 max-w-xl mx-auto text-sm md:text-base">
            Each program is thoughtfully designed to meet children at their developmental stage and spark a lifelong love of learning.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {programs.map((p, i) => (
            <div key={i} className="rounded-2xl border border-gray-200 bg-white hover:shadow-lg transition-shadow p-6 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <span className="text-3xl">{p.emoji}</span>
                <div>
                  <h3 className="font-bold text-gray-900 text-base">{p.label}</h3>
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${p.color}`}>Age {p.age}</span>
                </div>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── OUR STORY / TIMELINE ── */}
      <section className="bg-[rgb(122,49,125)] text-white py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-teal-300 font-semibold">Our History</span>
            <h2 className="text-3xl md:text-4xl font-extrabold mt-2">Our Story</h2>
          </div>
          <div className="relative">
            {/* Vertical line */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-teal-600 -translate-x-1/2" />
            <div className="space-y-8 md:space-y-0">
              {milestones.map((m, i) => (
                <div key={i} className={`md:flex items-center gap-8 md:mb-10 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}>
                  <div className={`flex-1 ${i % 2 === 0 ? "md:text-right" : "md:text-left"}`}>
                    <div className={`bg-white/10 backdrop-blur border border-white/20 rounded-2xl p-5 mb-4 md:mb-0 ${i % 2 === 0 ? "md:ml-auto" : "md:mr-auto"} max-w-sm`}>
                      <p className="text-sm text-teal-200 leading-relaxed">{m.text}</p>
                    </div>
                  </div>
                  {/* Dot */}
                  <div className="hidden md:flex flex-shrink-0 w-14 h-14 bg-orange-500 rounded-full items-center justify-center font-extrabold text-sm shadow-lg z-10">
                    {m.year}
                  </div>
                  <div className="flex-1" />
                </div>
              ))}
            </div>
            {/* Mobile timeline */}
            <div className="md:hidden space-y-4 mt-4">
              {milestones.map((m, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center font-bold text-xs text-white">
                    {m.year}
                  </div>
                  <div className="bg-white/10 border border-white/20 rounded-xl p-4 flex-1">
                    <p className="text-sm text-teal-100 leading-relaxed">{m.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── ABOUT CURRICULUM ── */}
      <section className="max-w-6xl mx-auto px-5 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="flex-1">
            <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Our Curriculum</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-5 leading-snug">
              A Distinctive Blend of Two <span className="text-teal-700">Proven Philosophies</span>
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Seekers Bay Preschool offers a comprehensive curriculum by combining <strong>Montessori pedagogy</strong> with Harvard's <strong>Multiple Intelligence (MI) theory</strong> — covering math, science, language arts, and geography while fostering creativity and exploration.
            </p>
            <div className="space-y-4">
              {[
                { icon: "🧠", title: "Personalized Learning", desc: "We cater to individual strengths and interests, allowing each child to learn in their own unique way." },
                { icon: "🌿", title: "Holistic Growth", desc: "Stimulating cognitive, social, emotional, and physical development in one nurturing environment." },
                { icon: "❤️", title: "Love of Learning", desc: "Creating a stimulating environment that encourages curiosity, exploration, and discovery every day." },
              ].map((item, i) => (
                <div key={i} className="flex gap-4 items-start">
                  <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center text-xl flex-shrink-0">
                    {item.icon}
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 text-sm mb-1">{item.title}</p>
                    <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1">
            <div className="rounded-3xl bg-gradient-to-br from-orange-50 to-yellow-50 border border-orange-100 p-8">
              <h3 className="font-extrabold text-gray-900 text-lg mb-5">8 Multiple Intelligences We Nurture</h3>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "🏃", label: "Bodily-Kinesthetic" },
                  { icon: "🎨", label: "Visual-Spatial" },
                  { icon: "📝", label: "Linguistic" },
                  { icon: "🔢", label: "Logical-Math" },
                  { icon: "🎵", label: "Musical" },
                  { icon: "🤝", label: "Interpersonal" },
                  { icon: "🧘", label: "Intrapersonal" },
                  { icon: "🌿", label: "Naturalist" },
                ].map((mi, i) => (
                  <div key={i} className="bg-white rounded-xl px-3 py-3 flex items-center gap-2.5 border border-orange-100 shadow-sm">
                    <span className="text-xl">{mi.icon}</span>
                    <span className="text-xs font-semibold text-gray-700">{mi.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOUNDER ── */}
      <section className="bg-gray-50 py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center mb-10">
            <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Leadership</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">Meet Our Founder</h2>
          </div>
          {team.map((t, i) => (
  <div key={i} className="max-w-2xl mx-auto bg-white border border-gray-200 rounded-3xl p-8 shadow-sm flex flex-col sm:flex-row items-center gap-7">
    <div className="w-33 h-36 rounded-full flex-shrink-0 overflow-hidden bg-gray-200">
      <img 
        src={Image2}
        alt={t.name}
        className="w-full h-full object-cover"
      />
    </div>
    <div>
      <h3 className="font-extrabold text-gray-900 text-xl mb-0.5">{t.name}</h3>
      <p className="text-teal-700 font-semibold text-sm mb-3">{t.role}</p>
      <p className="text-gray-600 text-sm leading-relaxed">{t.bio}</p>
    </div>
  </div>
))}
        </div>
      </section>

      {/* ── OUR TEACHERS ── */}
      <section className="max-w-6xl mx-auto px-5 py-16 md:py-20">
        <div className="mx-auto max-w-3xl">
          <div className="flex-1 text-center">
            <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Our Team</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4">Our Teachers</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Our teachers are highly trained professionals in early education and are passionate about early childhood learning. They are dedicated to providing a warm and nurturing preschool environment that encourages your child's growth and development.


            </p>
            <div className="grid grid-cols-1 gap-3 text-left sm:grid-cols-2">
              {["Highly Trained Professionals", "Passionate Educators", "Warm & Nurturing", "Individual Attention"].map((item, i) => (
                <div key={i} className="flex items-center gap-2">
                  <span className="w-5 h-5 bg-teal-600 rounded-full flex items-center justify-center text-white text-xs flex-shrink-0">✓</span>
                  <span className="text-gray-700 text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── BRANCHES ── */}
      <section className="bg-teal-50 py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-5">
          <div className="text-center mb-10">
            <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Our Locations</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">Visit Our Branches</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                name: "Rayasandra Branch",
                address: "3, Rayasandra Gattahalli Main Road, Rayasandra, Bangalore (Near SJR Parkway Homes)",
                pin: "560099",
                phone: "76187 59333",
                emoji: "📍",
              },
              {
                name: "Naganathapura Branch",
                address: "Seekers Bay Naganathapura, 42, 3rd Main Road, SLV Layout, Naganathapura, Bangalore",
                pin: "560100",
                phone: "76187 59333",
                emoji: "📍",
              },
            ].map((b, i) => (
              <div key={i} className="bg-white border border-teal-200 rounded-2xl p-6 hover:shadow-md transition-shadow">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-700 rounded-xl flex items-center justify-center text-white text-2xl flex-shrink-0">
                    {b.emoji}
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-base mb-1">{b.name}</h3>
                    <p className="text-gray-600 text-sm mb-3 leading-relaxed">{b.address}</p>
                    <div className="flex flex-wrap gap-3">
                      <span className="bg-teal-100 text-teal-800 text-xs font-semibold px-3 py-1 rounded-full">📮 {b.pin}</span>
                      <span className="bg-orange-100 text-orange-700 text-xs font-semibold px-3 py-1 rounded-full">📞 {b.phone}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-6 text-sm text-gray-500">
            <strong>Hours:</strong> Open today: 08:30 am – 05:00 pm &nbsp;|&nbsp; School time: Monday to Saturday, 08:30 am – 05:00 pm &nbsp;|&nbsp; Sunday Closed
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section id="faq" className="max-w-4xl mx-auto px-5 py-16 md:py-20">
        <div className="text-center mb-10">
          <span className="text-xs uppercase tracking-widest text-orange-500 font-semibold">Got Questions?</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">Frequently Asked Questions</h2>
          <p className="text-gray-500 mt-2 text-sm">
            Can't find your answer?{" "}
            <a href="mailto:preethi@seekersbay.in" className="text-teal-700 underline font-semibold">
              preethi@seekersbay.in
            </a>
          </p>
        </div>
        <FAQ />
      </section>

      {/* ── CTA BANNER ── */}
      <section id="contact" className="bg-[rgb(122,49,125)] text-white py-14 px-5">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-4xl block mb-4">🌱</span>
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4">Let's Start Your Child's Bright Learning Journey</h2>
          <p className="text-teal-200 mb-8 text-sm md:text-base max-w-lg mx-auto">
            Admissions Open — Avail our Early Bird Offer today. Reach out to our caring team to know more.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="mailto:preethi@seekersbay.in" className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-3.5 rounded-full transition-all text-sm shadow-lg">
              Enquire Now →
            </a>
            <a href="tel:7618759333" className="border border-white/40 hover:bg-white/10 text-white font-semibold px-8 py-3.5 rounded-full transition-all text-sm">
              📞 76187 59333
            </a>
          </div>
          <div className="mt-8 flex justify-center gap-4">
            <a href="https://www.facebook.com/SeekersBayPreschool" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/30 hover:bg-white/10 flex items-center justify-center text-sm font-bold transition-all">f</a>
            <a href="https://www.instagram.com/seekersbaypreschool/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/30 hover:bg-white/10 flex items-center justify-center text-sm transition-all">▣</a>
          </div>
        </div>
      </section>
    </div>
  );
}
